import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Field } from 'redux-form';

import { TextInput, SelectInput, SwitchInput, EmptyState } from '../../_Components';
import { Options } from '../../_utils/_constants';

const TypeOptions = Options.FieldsTypesOptions;

const ColSettings = ({ selectedIndex, fields = [], path, item, items, combobox }) => {
    if (!item || selectedIndex < 0) {
        return (
            <EmptyState
                title="Поле не выбрано"
                description="Кликните поле в форме, чтобы настроить его."
            />
        );
    }

    const current = (fields || []).find((entry) => entry.id === item.field);
    const type = current ? current.type : '';

    return (
        <Fragment>
            <div className="pc-sect">
                <div className="pc-fgrid">
                    <div className="pc-f--full">
                        <Field
                            name={`${path}[${selectedIndex}].field`}
                            required={true}
                            component={SelectInput}
                            options={(fields || [])
                                .filter((entry) => items.map((row) => row.field).indexOf(entry.id) < 0 || item.field === entry.id)
                                .slice()
                                .sort((a, b) => String(a.name || a.id).localeCompare(String(b.name || b.id), 'ru'))
                                .map((entry) => ({ id: entry.id, name: entry.name || entry.id, login: entry.id }))}
                            label="Поле"
                            searchable
                            showValue
                            searchPlaceholder="Название или ключ"
                        />
                    </div>
                    <Field
                        name={`${path}[${selectedIndex}].field`}
                        component={TextInput}
                        label="Ключ"
                        disabled={true}
                        mono={true}
                    />
                    <SelectInput
                        label="Тип"
                        value={type}
                        disabled={true}
                        options={TypeOptions}
                    />
                </div>
                <div className="pc-field__hint">Тип задаётся во вкладке «Поля» проекта.</div>
                {['select', 'multiselect', 'radio'].indexOf(type) >= 0 && (
                    <div style={{ marginTop: 12 }}>
                        <Field
                            name={`${path}[${selectedIndex}].default`}
                            component={SelectInput}
                            options={combobox}
                            label="Значение по умолчанию"
                        />
                    </div>
                )}
            </div>
            <div className="pc-sect">
                <div className="pc-sect__t">В этой карточке</div>
                <div className="pc-togrow">
                    <div className="pc-togrow__txt">
                        <b>Обязательное</b>
                        <span>Без него карточку не закрыть</span>
                    </div>
                    <Field name={`${path}[${selectedIndex}].required`} component={SwitchInput} />
                </div>
                <div className="pc-togrow">
                    <div className="pc-togrow__txt">
                        <b>Только чтение</b>
                        <span>Оператор видит, но не меняет</span>
                    </div>
                    <Field name={`${path}[${selectedIndex}].readonly`} component={SwitchInput} />
                </div>
                <div className="pc-togrow">
                    <div className="pc-togrow__txt">
                        <b>Поле CRM</b>
                        <span>Подставить значение из найденной записи</span>
                    </div>
                    <Field name={`${path}[${selectedIndex}].crm`} component={SwitchInput} />
                </div>
                {type === 'phone' && (
                    <div className="pc-togrow">
                        <div className="pc-togrow__txt">
                            <b>Телефон звонящего</b>
                            <span>Заполнить номером из вызова</span>
                        </div>
                        <Field name={`${path}[${selectedIndex}].callPhone`} component={SwitchInput} />
                    </div>
                )}
                {type === 'name' && (
                    <div className="pc-togrow">
                        <div className="pc-togrow__txt">
                            <b>Полное имя</b>
                            <span>Собрать ФИО из отдельных полей</span>
                        </div>
                        <Field name={`${path}[${selectedIndex}].full_name`} component={SwitchInput} />
                    </div>
                )}
            </div>
        </Fragment>
    );
};

const mapStateToProps = (state) => {
    const { fetch } = state;
    return {
        isLoading: !!fetch.loading
    };
};

export default compose(
    connect(mapStateToProps),
)(ColSettings);
